import posthog from 'posthog-js'

export function usePostHog() {
    if (window.POSTHOG_API_KEY && window.POSTHOG_API_HOST) {
        posthog.init(window.POSTHOG_API_KEY, {
            api_host: window.POSTHOG_API_HOST,
        })
    }

    return { posthog }
}
